import { merge } from "theme-ui"
import baseTheme from "@lekoarts/gatsby-theme-minimal-blog/src/gatsby-plugin-theme-ui/index"

// サイト用の配色・フォントをベーステーマにマージ
const custom = {
  colors: {
    text: "#1f1f1f",
    background: "#ffffff",
    primary: "#5b3cc4",
    secondary: "#6B46C1",
    heading: "#1f1f1f",
    modes: {
      dark: {
        text: "#e6e7f0",
        background: "#0f0f17",
        primary: "#7f6bff",
        secondary: "#c9c4ff",
        heading: "#ffffff",
        muted: "#1a1a24",
      },
    },
  },
  fonts: {
    body: "'Helvetica Neue', 'Hiragino Sans', 'Yu Gothic UI', 'Segoe UI', system-ui, -apple-system, sans-serif",
    heading: "'Helvetica Neue', 'Hiragino Sans', 'Yu Gothic UI', 'Segoe UI', system-ui, -apple-system, sans-serif",
    monospace: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
  },
  styles: {
    root: {
      backgroundColor: "background",
      color: "text",
    },
    h1: { fontWeight: 700, letterSpacing: "-0.02em" },
    h2: { fontWeight: 700, letterSpacing: "-0.02em" },
    h3: { fontWeight: 700, letterSpacing: "-0.01em" },
    p: { lineHeight: 1.8 },
    a: { color: "primary", textDecoration: "none", ":hover": { textDecoration: "underline" } },
  },
  layout: {
    container: {
      padding: [2, 3],
      maxWidth: "1024px",
    },
    main: {
      bg: "background",
      color: "text",
      paddingTop: [1, 2],
      "> section": { marginBottom: 0 },
    },
  },
}

const theme = merge(baseTheme, custom)

export default theme
